import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import {
  Current_User,
  Recoil_Quarter_State,
  System_Date_Time_State,
  Refresh_Pl_Forecast_page,
  Is_Opps_Bad_Data_Available_State,
  Refresh_Pills_Status_State,
} from '@recoil/recoil';
import AlertBanner from '@atoms/alerts/alertBanner';
import { getAlertBarDetails, logError } from '@util/commonFunctions';

const DashboardAlerts = props => {
  const screenName = props.screenName;
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const [alertBarInfo, setAlertBarInfo] = useState({});

  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const refreshPlForecastPage = useRecoilValue(Refresh_Pl_Forecast_page);
  const isOppsBadDataAvailable = useRecoilValue(Is_Opps_Bad_Data_Available_State);
  const refreshPillStatus = useRecoilValue(Refresh_Pills_Status_State);

  let alertStatusDetails = null;

  const fetchForecastSubmitStatus = async () => {
    if (!quarterData) {
      return;
    }
    const apiPayload = {
      email: localStorage.getItem('mslDelegate')
        ? localStorage.getItem('mslDelegate')
        : currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
      read_only: localStorage.getItem('isReadOnly') === 'true' ? true : false,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        quarterData,
        apiPayload,
        screenName,
        systemDateTime,
      );
      setAlertBarInfo(alertStatusDetails);
    } catch (error) {
      logError('getAlertBarDetails', error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem('isReadOnly')) {
        fetchForecastSubmitStatus();
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [quarterData, refreshPlForecastPage, refreshPillStatus]);

  // Added for refreshing alert banner
  useEffect(() => {
    if (isOppsBadDataAvailable !== null) {
      fetchForecastSubmitStatus();
    }
  }, [isOppsBadDataAvailable]);

  return (
    <>
      <AlertBanner
        title={alertBarInfo?.title}
        description={alertBarInfo?.description}
        type={alertBarInfo?.type}
        showButton={alertBarInfo?.showButton}
        modifyStyle={alertBarInfo?.modifyStyle}
      />
    </>
  );
};

export default DashboardAlerts;
